import { customElement, property } from "lit/decorators.js";
import { html, nothing } from "lit";
import { BaseComponent } from "../../base-component/base-component";
import { ProductCardData } from "../product-card-display";
import '../product-card-display/product-card-metadata.display';
import { CtaTypeLabel } from "../product.interface";
import { emitProductAnalyticsEvent } from "../utils/product-card.analytics.util";
import { getProductUrl } from "../utils/product-card.util";
import { SEG_LOWER } from "../../../common/utils/util";

@customElement('mhecomm-k12-program-list-display')
export class K12ProgramListDisplay extends BaseComponent {
  
  @property({ type: Object })
  product?: ProductCardData;

  @property({ type: Boolean })
  showBusinessLabelType = true;

  @property({ type: String })
  businessLabelType = 'Program';

  @property({ type: String })
  cta = CtaTypeLabel.VIEW_ITEM;

  renderComp() {
    return this.product
      ? html `
          <div class="lh-base">
            <mhecomm-product-card-metadata-display
              .product="${this.product}"
              businessLabelType=${this.businessLabelType}
              descriptionFontSize="fs-6"
              ?showBusinessLabelType=${this.showBusinessLabelType}
              ?showDescription=${true}
              ?showGrades=${true}
              ?showCopyright=${false}
              titleWeight="semibold"
              titleHref="${getProductUrl(this.product)}"
              .titleClickListener=${(e: Event) => {
                e.preventDefault();
                const target = e.currentTarget as HTMLAnchorElement;
                emitProductAnalyticsEvent(this, this.product!, SEG_LOWER, 'mhecomm-k12-program-list');
                window.location.href = target.href;
              }}
            >
            </mhecomm-product-card-metadata-display>
          </div>`
      : nothing
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-k12-program-list-display': K12ProgramListDisplay;
  }
}